import React from "react";
import { ShieldAlert } from "lucide-react";

/**
 * Renforced, non-dismissible pedagogical warning for the judgment simulation.
 * Used twice: at the top of the wizard page AND inside the judgment document.
 */
export default function JudgmentWarningBanner({ compact = false }) {
  return (
    <div
      role="alert"
      data-testid="judgment-warning-banner"
      className={`rounded-lg border-2 border-rose-500/70 bg-rose-50 text-rose-950 shadow-sm dark:border-rose-400/60 dark:bg-rose-950/50 dark:text-rose-100 ${
        compact ? "p-3" : "p-4"
      }`}
    >
      <div className="flex gap-3">
        <ShieldAlert
          className={`${
            compact ? "mt-0.5 h-4 w-4" : "mt-0.5 h-5 w-5"
          } shrink-0 text-rose-600 dark:text-rose-300`}
        />
        <div className="space-y-1 text-sm leading-relaxed">
          <div className="font-bold uppercase tracking-wide">
            ⚠️ Simulation pédagogique uniquement
          </div>
          <p>
            Ce jugement est généré automatiquement à titre illustratif
            conformément à la Nouvelle Théorie des Finances Publiques
            <em> (ELY Mustapha)</em>. Il ne constitue <strong>en aucun cas</strong>{" "}
            une décision de justice, un avis d'avocat, ou un acte juridique
            quelconque. Toute utilisation à des fins autres que pédagogiques est
            de la <strong>seule responsabilité</strong> de l'utilisateur.
          </p>
        </div>
      </div>
    </div>
  );
}
